<template>
  <div
    class="modal fade ag-modal ag-scope-modal"
    id="scopeModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="ag-modal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Change Target Scope</h3>
          <div class="search-scope mr-4">
            <input
              type="text"
              class="form-control"
              name="search"
              id="searchInput"
              autofocus
              v-model="search"
              placeholder="Type to filter"
              maxlength="191"
            />
          </div>
        </div>

        <div class="">
          <ag-loading v-if="loading" />
          <!-- AGMSAdmin -->
          <ul class="tree" id="admin" v-if="!loading">
            <label class="not-found" v-if="filteredPartners.length === 0">
              no matching result
            </label>
            <li v-if="filteredPartners.length">
              <input type="checkbox" checked="checked" id="global" />
              <label class="tree_label" for="global">
                <span
                  @click="setGlobal()"
                  v-if="realRole === Roles.AGMSAdmin"
                  class="global-label"
                  >Global Scope</span
                >
                <span v-if="realRole !== Roles.AGMSAdmin"> </span>
              </label>
              <ul>
                <li v-for="(partnerItem, ckey) in filteredPartners" :key="ckey">
                  <input
                    type="checkbox"
                    :id="partnerItem.guid"
                    :checked="checkIsSelected(partnerItem)"
                    v-if="partnerItem.nodes.length"
                  />
                  <label
                    :for="partnerItem.guid"
                    class="tree_label"
                    v-if="partnerItem.nodes.length"
                  >
                    <span
                      v-if="realRole !== Roles.SiteAdmin"
                      @click="changeScope(partnerItem, null, null)"
                      :class="getClass(partnerItem)"
                      v-html="
                        $filters.highlight(
                          partnerItem.name ? partnerItem.name : '',
                          search
                        )
                      "
                    ></span>
                  </label>
                  <span
                    class="tree_label"
                    @click="changeScope(partnerItem, null, null)"
                    style="cursor: pointer"
                    :class="getClass(partnerItem)"
                    v-if="partnerItem.nodes && partnerItem.nodes.length === 0"
                    v-html="
                      $filters.highlight(
                        partnerItem.name ? partnerItem.name : '',
                        search
                      )
                    "
                  ></span>
                  <ul v-if="partnerItem.nodes">
                    <li
                      v-for="(companyItem, ckey) in filterCompanies(
                        partnerItem.nodes
                      )"
                      :key="ckey"
                    >
                      <input
                        type="checkbox"
                        :id="companyItem.guid"
                        :checked="checkIsSelected(companyItem)"
                        v-if="companyItem.nodes && companyItem.nodes.length"
                      />
                      <label
                        :for="companyItem.guid"
                        :class="{
                          tree_label:
                            companyItem.nodes && companyItem.nodes.length > 0,
                        }"
                        v-if="companyItem.nodes && companyItem.nodes.length"
                      >
                        <span
                          @click="changeScope(companyItem, partnerItem, null)"
                          :class="getClass(companyItem)"
                          v-html="
                            $filters.highlight(
                              companyItem.name ? companyItem.name : '',
                              search
                            )
                          "
                        ></span>
                      </label>
                      <span
                        class="tree_label"
                        @click="changeScope(companyItem, partnerItem, null)"
                        style="cursor: pointer"
                        v-if="
                          companyItem.nodes && companyItem.nodes.length === 0
                        "
                        :class="getClass(companyItem)"
                        v-html="
                          $filters.highlight(
                            companyItem.name ? companyItem.name : '',
                            search
                          )
                        "
                      ></span>
                      <ul v-if="companyItem.nodes">
                        <li
                          v-for="(siteItem, skey) in filterSites(
                            companyItem.nodes
                          )"
                          :key="skey"
                        >
                          <input
                            type="checkbox"
                            :checked="checkIsSelected(siteItem)"
                            :id="siteItem.guid"
                            v-if="siteItem.nodes && siteItem.nodes.length"
                          />
                          <label
                            :for="siteItem.guid"
                            :class="'tree_label'"
                            v-if="siteItem.nodes && siteItem.nodes.length"
                          >
                            <span
                              @click="
                                changeScope(siteItem, companyItem, partnerItem)
                              "
                              :class="getClass(siteItem)"
                              v-html="
                                $filters.highlight(
                                  siteItem.name ? siteItem.name : '',
                                  search
                                )
                              "
                            ></span>
                          </label>
                          <label
                            v-if="
                              !siteItem.nodes || siteItem.nodes.length === 0
                            "
                          >
                            <span
                              class="tree_label"
                              style="cursor: pointer"
                              @click="
                                changeScope(siteItem, companyItem, partnerItem)
                              "
                              :class="getClass(siteItem)"
                              v-html="
                                $filters.highlight(
                                  siteItem.name ? siteItem.name : '',
                                  search
                                )
                              "
                            ></span>
                          </label>

                          <ul v-if="siteItem.nodes">
                            <li
                              v-for="(group, gkey) in filterGroups(
                                siteItem.nodes
                              )"
                              :key="gkey"
                            >
                              <label>
                                <span
                                  class="tree_label"
                                  style="cursor: pointer"
                                  @click="
                                    changeScope(group, siteItem, companyItem)
                                  "
                                  :class="getClass(group)"
                                  v-html="
                                    $filters.highlight(
                                      group.name ? group.name : '',
                                      search
                                    )
                                  "
                                ></span>
                              </label>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="border-0 ag-button ag-button_radius pr-4 pl-4 ag-button_secondary"
            data-dismiss="modal"
          >
            {{$t("cancel")}}
          </button>
        </div>
      </div>
    </div>
    <iframe
      :src="agmsUrlForCompany"
      @load="onLoadIframe"
      frameborder="0"
      width="0px"
      height="0px"
      v-if="agmsUrlForCompany"
    ></iframe>
    <iframe
      :src="agmsUrlCompanyForSiteGroup"
      @load="onLoadIframeForSiteGroup"
      frameborder="0"
      width="0px"
      height="0px"
      v-if="agmsUrlCompanyForSiteGroup"
    ></iframe>
    <button
      class="hidden scope-modal"
      data-toggle="modal"
      data-target="#scopeModal"
    >
      {{$t("changeScope")}}
    </button>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions, mapGetters } from "vuex";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { AuthActionTypes } from "@/store/modules/auth/action-types";
import { useStore } from "@/store";
import api from "@/api/index";
import AgLoading from "@/components/ag-loading/index.vue";
import { Roles } from "@/helpers/enums/Roles";
import apiAGSC from "@/store/axiosAgsc";

const store = useStore();

export default {
  name: "ag-scope-modal",
  data() {
    return {
      loading: true,
      siteGroups: [],
      Roles: Roles,
      allSites: [],
      allGroups: [],
      partners: [],
      agmsUrlForCompany: null,
      selectedPartnerData: null,
      selectedCompanyData: null,
      agmsUrlCompanyForSiteGroup: null,
      search: null,
      loadCount: 0,
    };
  },
  computed: {
    ...mapGetters([
      "user",
      "mainUser",
      "site",
      "group",
      "company",
      "partner",
      "sites",
      "groups",
      "loggedInUser",
    ]),
    realRole() {
      return localStorage.getItem("realRole");
    },
    selectedRole() {
      return localStorage.getItem("selectedRole");
    },
    selectedScopeId() {
      return localStorage.getItem("selectedScopeId");
    },
    filteredPartners() {
      if (this.search) {
        return this.findInObjArray(
          (this.partners.nodes ? this.partners.nodes : []),
          this.search
        );
      }
      return this.partners.nodes;
    },
    scopeModalStatus() {
      return store.state.general.scopeModalStatus;
    },
  },
  watch: {
    scopeModalStatus(newValue, oldValue) {
      if (newValue) {
        this.init();
      }
    },
  },
  mounted() {
    let tempUser = this.mainUser;
    if (!localStorage.getItem("realRole")) {
      const roleIndex = tempUser.findIndex((i) => i.type === "role");
      localStorage.setItem("realRole", tempUser[roleIndex].value);
    }
    if (localStorage.getItem("selectedRole")) {
      this.changeRole(localStorage.getItem("selectedRole"));
      this.changeRole(localStorage.getItem("selectedRole"));
    } else {
      localStorage.setItem("selectedRole", this.loggedInUser.role);
      this.changeRole(localStorage.getItem("selectedRole"));
    }
    this.getAllSites();

    if (localStorage.getItem("partner")) {
      this.setPartner(JSON.parse(localStorage.getItem("partner")));
    }

    if (this.loggedInUser.role === Roles.PartnerAdmin && !this.partner) {
      const partner = this.partners.nodes[0];
      // this.changePartner(partner);
    }
    if (this.loggedInUser.role === Roles.CompanyAdmin && !this.company) {
      const company = this.partners[0].nodes[0];
      this.changeCompany(company);
    }
    if (
      this.loggedInUser.role === Roles.GroupAdmin &&
      Object.keys(this.group).length === 0
    ) {
      // $(".scope-modal").click();
    }
    if (
      this.loggedInUser.role === Roles.SiteAdmin &&
      Object.keys(this.site).length === 0
    ) {
      // $(".scope-modal").click();
    }
  },
  methods: {
    ...mapActions({
      setCompany: AuthActionTypes.SET_COMPANY,
      setPartner: AuthActionTypes.SET_PARTNER,
      setUser: AuthActionTypes.SET_USER,
      setBreadcrumbData: GeneralActionTypes.SET_AGMS_BREADCRUMB_DATA,
      setBreadcrumbStatus: GeneralActionTypes.SET_AGMS_BREADCRUMB_STATUS,
      setSite: AuthActionTypes.SET_SITE,
      setGroup: AuthActionTypes.SET_GROUP,
      getSections: GeneralActionTypes.GET_SECTIONS,
    }),
    async init() {
      this.loading = true;
      this.search = null;
      this.agmsUrlForCompany = null;
      this.selectedPartnerData = null;
      this.selectedCompanyData = null;
      this.agmsUrlCompanyForSiteGroup = null;
      this.loadCount = 0;
      const resCompany = await api.companies.getScopeTree();
      this.partners = resCompany.data.entityData;
      this.loading = false;
      document.getElementById("searchInput").focus();
    },
    setGlobal() {
      if (this.changeRole(Roles.AGMSAdmin)) {
        this.clearSiteAndGroup();
        this.setCompany({});
        this.setSite({});
        this.setGroup({});
        this.setPartner({});
        location.href = "/administration/manage-partners";
      }
    },
    filterGroups(groups) {
      if (this.search) {
        return this.findInObjArray((groups ? groups : []), this.search);
      }
      return groups;
    },
    filterSites(sites) {
      if (this.search) {
        return this.findInObjArray((sites ? sites : []), this.search);
      }
      return sites;
    },
    filterCompanies(companies) {
      // if (this.search) {
      //   return this.findInObjArray((companies ? companies : []), this.search);
      // }
      return companies;
    },
    checkIsSelected(data) {
      let status = data.guid === this.selectedScopeId;
      if (data.nodes) {
        data.nodes.forEach((element) => {
          if (element.guid === this.selectedScopeId) {
            status = true;
          }
          if (element.nodes) {
            element.nodes.forEach((subItem) => {
              if (subItem.guid === this.selectedScopeId) {
                status = true;
              }
              if (subItem.nodes) {
                subItem.nodes.forEach((subItem2) => {
                  if (subItem2.guid === this.selectedScopeId) {
                    status = true;
                  }
                });
              }
            });
          }
        });
      }
      return status || (this.search && this.search.length);
    },
    findInObjArray(array, value) {
      var found = [];
      function findInObj(obj, value) {
        try {
          return Object.values(obj).some((v) =>
            typeof v == "object" && v != "null"
              ? findInObj(v, value)
              : typeof v == "string"
              ? (v ? v : "")
                  .toLowerCase()
                  .includes((value ? value : "").toLowerCase())
              : typeof v == "number"
              ? v === value || (isNaN(v) && isNaN(value))
              : v === value
          );
        } catch (error) {
          return false;
        }
      }
      array.forEach(function (obj) {
        try {
          if (obj && findInObj(obj, value)) found.push(obj);
        } catch (e) {
          console.log(e, obj);
        }
      });
      return found;
    },
    onLoadIframe() {
      this.clearSiteAndGroup();
      this.setCompany(this.selectedCompanyData);
      localStorage.setItem("company", JSON.stringify(this.selectedCompanyData));
      if (this.loadCount === 0) {
        const url = this.agmsUrlForCompany;
        this.agmsUrlForCompany = null;
        ++this.loadCount;
        this.agmsUrlForCompany = url;
      }
      setTimeout(() => {
        location.href = "/dashboard/company-overview";
      }, 2000);
    },
    onLoadIframeForSiteGroup() {
      if (this.loadCount === 0) {
        const url = this.agmsUrlCompanyForSiteGroup;
        this.agmsUrlCompanyForSiteGroup = null;
        ++this.loadCount;
        this.agmsUrlCompanyForSiteGroup = url;
      }
      setTimeout(() => {
        location.href = "/dashboard/company-overview";
      }, 2000);
    },
    getClass(data) {
      if (data.type === 0) {
        return "partner-label";
      } else if (data.type === 1) {
        return "company-label";
      } else if (data.type === 2) {
        return "site-label";
      } else if (data.type === 3) {
        return "group-label";
      }
    },
    changeScope(data, child, child2) {
      localStorage.setItem("selectedScopeId", data.guid);
      localStorage.setItem("agms_template", JSON.stringify({}));
      // 0 partner
      // 1 company
      // 2 site
      // 3 group
      if (data.type === 0) {
        this.changePartner(data);
      } else if (data.type === 1) {
        this.changeCompany(data);
      } else if (data.type === 2) {
        this.changeSite(child, data);
      } else if (data.type === 3) {
        this.changeGroup(child2, child, data);
      }

      if (child.type == 0) {
        localStorage.setItem("partner", JSON.stringify(child));
      }
      if (child2.type == 0) {
        localStorage.setItem("partner", JSON.stringify(child2));
      }
    },
    changePartner(partner) {
      if (this.changeRole(Roles.PartnerAdmin)) {
        localStorage.setItem("partner", JSON.stringify(partner));
        this.agmsUrlForCompany =
          process.env.VUE_APP_AGMS_URL +
          `/MultiTenant/ManageCompany/AGMSDashboard?partnerId=${partner.guid}`;
        this.selectedPartnerData = partner;
      }
    },
    changeCompany(company) {
      if (this.changeRole(Roles.CompanyAdmin)) {
        const companyData = {
          companyGuid: company.guid,
          companyId: company.mainid,
          companyName: company.name,
        };
        this.agmsUrlForCompany =
          process.env.VUE_APP_AGMS_URL +
          `/MultiTenant/ManageCompany/AGMSDashboard?companyId=${company.guid}`;
        this.selectedCompanyData = companyData;
      }
    },
    changeSite(company, site) {
      if (this.changeRole(Roles.SiteAdmin)) {
        let siteData = {};
        let companyData = {};
        siteData = {
          key: site.guid,
          value: site.name,
          mainid: site.mainId,
        };
        companyData = {
          companyGuid: company.guid,
          companyId: company.guid,
          companyName: company.name,
        };
        localStorage.setItem("company", JSON.stringify(companyData));
        this.clearSiteAndGroup();
        localStorage.setItem("site", JSON.stringify(siteData));
        this.setSite(siteData);
        this.setCompany(companyData);
        this.agmsUrlCompanyForSiteGroup =
          process.env.VUE_APP_AGMS_URL +
          `/MultiTenant/ManageCompany/AGMSDashboard?companyId=${company.guid}`;
      }
    },
    changeGroup(company, site, group) {
      console.log(group);
      if (this.changeRole(Roles.GroupAdmin)) {
        this.clearSiteAndGroup();
        let groupData = {};
        let siteData = {};
        let companyData = {};
        groupData = {
          key: group.guid,
          value: group.name,
          mainid: group.mainId,
        };
        siteData = {
          key: site.guid,
          value: site.name,
          mainid: site.mainId,
        };
        companyData = {
          companyGuid: company.guid,
          companyId: company.mainid,
          companyName: company.name,
        };
        localStorage.removeItem("partner");
        localStorage.setItem("company", JSON.stringify(companyData));
        localStorage.setItem("site", JSON.stringify(siteData));
        localStorage.setItem("group", JSON.stringify(groupData));
        this.setSite(siteData);
        this.setGroup(groupData);
        this.setCompany(companyData);
        this.agmsUrlCompanyForSiteGroup =
          process.env.VUE_APP_AGMS_URL +
          `/MultiTenant/ManageCompany/AGMSDashboard?companyId=${company.guid}`;
      }
    },
    async getAllSites() {
      localStorage.setItem("withoutSiteHeader", true);
      const res = await api.sites.get();
      this.allSites = res.data.entityData;
      localStorage.removeItem("withoutSiteHeader");
      this.getAllGroups();
    },
    async getAllGroups() {
      localStorage.setItem("withoutGroupHeader", true);
      const res = await api.groups.get();
      this.allGroups = res.data.entityData;
      localStorage.removeItem("withoutGroupHeader");
      if (this.realRole === Roles.SiteAdmin) {
        this.getSiteGroups();
      }
    },
    async getSiteGroups() {
      this.allSites.forEach(async (element) => {
        apiAGSC
          .get(`/Asset/GetAllGroupsForSite?siteGuid=${element.siteGuid}`, {})
          .then((resp) => {
            const groupIds = resp.data.entityData.groupGuids;
            element.groups = this.groups.filter(
              (i) => groupIds.indexOf(i.key) > -1
            );
            this.siteGroups.push(element);
          });
      });
    },
    changeRole(role) {
      let tempUser = this.mainUser;
      const roleIndex = tempUser.findIndex((i) => i.type === "role");
      localStorage.setItem("scopeChange", true);
      localStorage.setItem("selectedRole", role);
      localStorage.setItem("changingScope", true);
      if (roleIndex > -1) {
        tempUser[roleIndex].value = role;
        this.setUser(tempUser);
        this.loading = true;
        return true;
      }
      return false;
    },
    clearSiteAndGroup() {
      this.setBreadcrumbData({});
      this.setBreadcrumbStatus(false);
      localStorage.setItem("site", JSON.stringify({}));
      localStorage.setItem("group", JSON.stringify({}));
      this.setSite({});
      this.setGroup({});
    },
  },
  components: { AgLoading },
};
</script>

<style lang="scss" scoped>
ul,
li,
label {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}
body {
  line-height: 1;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}
*,
*::before,
*::after {
  box-sizing: content-box;
}

.global-label {
  background: #dadce0;
  padding: 6px 12px;
  border-radius: 24px;
}

.partner-label::before {
  content: "P";
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background: #90cde7;
  color: #376280;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
  font-size: 18px;
}
.company-label::before {
  content: "C";
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background: #edd87e;
  color: #376280;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
  font-size: 18px;
}
.site-label::before {
  content: "S";
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background: #85cab2;
  color: #376280;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
  font-size: 18px;
}
.group-label::before {
  content: "G";
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background: #bed1cb;
  color: #376280;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
  font-size: 18px;
}

.tree {
  margin: 3.5em;
  font-size: 18px !important;
}
.tree * {
  font-size: 18px !important;
}

.tree input {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}

.tree input ~ ul {
  display: none;
}

.tree input:checked ~ ul {
  display: block;
}

/* ————————————————————–
  Tree rows
*/
.tree li {
  line-height: 1.2;
  position: relative;
  padding: 0 0 1em 1em;
}

.tree ul li {
  padding: 1em 0 0 1em;
}

.tree > li:last-child {
  padding-bottom: 0;
}

/* ————————————————————–
  Tree labels
*/
.tree_label {
  position: relative;
  display: inline-block;
  letter-spacing: 0px;
  color: #4c8dbb;
}

.not-found {
  color: #fa4443;
  font-size: 16px !important;
  text-align: center;
  margin: 0 auto;
  display: flex;
  align-items: center;
  width: 100%;
  display: block;
}

label.tree_label {
  cursor: pointer;
}

label.tree_label:hover {
  color: #666;
}

/* ————————————————————–
  Tree expanded icon
*/
label.tree_label:before {
  background: #4c8dbb;
  color: #fff;
  position: relative;
  z-index: 1;
  float: left;
  margin: 0 1em 0 -2em;
  width: 1em;
  height: 1em;
  border-radius: 1em;
  content: "+";
  text-align: center;
  line-height: 0.9em;
}

:checked ~ label.tree_label:before {
  content: "-";
}

/* ————————————————————–
  Tree branches
*/
.tree li:before {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -0.5em;
  display: block;
  width: 0;
  border-left: 2px solid #d6dfe1;
  content: "";
}

.tree_label:after {
  position: absolute;
  top: 0;
  left: -1.5em;
  display: block;
  height: 0.5em;
  width: 1em;
  border-bottom: 2px solid #d6dfe1;
  border-left: 2px solid #d6dfe1;
  border-radius: 0 0 0 0.3em;
  content: "";
}

label.tree_label:after {
  border-bottom: 0;
}

:checked ~ label.tree_label:after {
  border-radius: 0 0.3em 0 0;
  border-top: 2px solid #d6dfe1;
  border-right: 2px solid #d6dfe1;
  border-bottom: 0;
  border-left: 0;
  bottom: 0;
  top: 0.5em;
  height: auto;
}

.tree li:last-child:before {
  height: 1em;
  bottom: auto;
}

.tree > li:last-child:before {
  display: none;
}

.tree_custom {
  display: block;
  background: #eee;
  padding: 1em;
  border-radius: 0.3em;
}

//////////
.policy__wrapper {
  padding-bottom: 36px;
  background-color: #fafafa;
  overflow: hidden;
  position: inherit;
}

.policy:first-child:before {
  width: 0px !important;
}

.company-admin {
  .policy__body__wrapper {
    margin-top: 2px;
  }

  .policy:first-child::before {
    width: 0px !important;
  }
}

.header-select-global {
  margin-top: 24px;
  padding: 24px;
  margin-bottom: -50px;
  &:after {
    content: "";
    height: 200vh;
    background: #d7dfe2;
    width: 2px;
    display: block;
    margin-left: 55px;
    margin-top: -14px;
    position: absolute;
    border-style: solid;
    border-width: 0 0 2px 2px;
    position: relative;
    /* float: right; */
    clear: none;
    /* right: -3px; */
    /* top: -3px; */
    background-color: transparent;
    width: 25px;
    height: 56px;
    position: absolute;
    border-color: #d8dfe3;
    z-index: 9;
  }
}

.header-select {
  margin-top: 24px;
  padding: 24px;
  margin-bottom: -50px;

  &:after {
    content: "";
    height: 200vh;
    background: #d7dfe2;
    width: 2px;
    display: block;
    margin-left: 55px;
    margin-top: -12px;
    position: absolute;
  }
}

.scope-tree {
  .policy {
    &.has-header {
      padding: 2px;
      position: relative;
      margin-left: 111px;
      margin-top: 20px;
      margin-bottom: -20px;
    }
    .policy__header {
      border: none !important;
      text-align: left;

      &:before {
        content: "";
        height: 2px;
        background: #d7dfe2;
        width: 40px;
        display: block;
        margin-left: -34px;
        margin-top: 10px;
        position: absolute;
      }

      .policy__header__title {
        text-align: left;
        margin-left: 12px;
      }
    }
  }
}

.policy {
  background-color: #fafafa;
  padding: 24px;
  position: relative;

  &.has-header {
    padding: 24px;
    position: relative;
    margin-left: 90px;
    margin-top: 20px;

    &:before {
      content: "";
      background: #d8dfe3;
      width: 0px !important;
    }
  }

  &:before {
    content: "";
    background: #d8dfe3;
    width: 2px;
    height: calc(100% - 45px);
    margin-left: 28px;
    position: absolute;
    top: 71px;
  }

  &__header:first-child {
    width: auto;
    min-width: 120px;
    display: inline-block;
    text-align: center;
    margin-bottom: 12px;
  }

  &__header {
    display: flex;
    background-color: #fafafa;
    font: normal normal normal 16px/22px Open Sans;
    letter-spacing: 0px;
    color: #4c8dbb;
    border: solid #d8dfe3;
    border-width: 0px 0 2px 0;
    align-items: center;
    cursor: pointer;
    padding: 12px 0;

    &__arrow {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right: 5px;
      transition: 0.5s cubic-bezier(0, 1, 0, 1);

      border: 1px solid #4c8dbb;
      padding: 3px;
      color: #4c8dbb;
      cursor: pointer;

      &::after {
        display: block;
        content: "+";
        font-size: 21px;
        font-family: Arial, Helvetica, sans-serif;
        margin-top: -6px;
        margin-left: -3px;
      }

      &--active::after {
        content: "-";
        font-size: 21px;
        font-family: Arial, Helvetica, sans-serif;
        margin-top: -8px;
        display: block;
        margin-left: 0px;
      }
    }

    &__title {
      flex-grow: 2;
      max-width: 40vw;

      &.disabled {
        color: #939393 !important;
      }
    }

    &__gap {
      flex-grow: 1;
    }
  }

  &__body {
    overflow: hidden;
    max-height: 0;
    transition: 0.3s ease-in-out;
    padding-bottom: 0;

    &--active {
      max-height: 1000px;
      transition: max-height 0.3s ease-in-out;
    }
  }

  & &__body {
    .policy {
      padding-top: 0;
      border-top: 0;
      background-color: transparent;
      position: static;

      &__header {
        background-color: transparent;
        padding-left: 45px;
        border: none;
        position: relative;

        &:before {
          content: unset;
          display: none;
        }

        &__title {
          max-width: calc(40vw - 100px);
          margin-left: 6px;
          border-bottom: 2px solid #d8dfe2;
          padding-bottom: 10px;

          &:before {
            content: "";
            background-color: #d8dfe3;
            position: absolute;
            display: block;
            width: 55px;
            height: 2px;
            left: 28px;
            margin-top: -11px;
          }
        }

        &__arrow {
          height: 16px;
          margin-left: 48px;
        }

        &:after {
          content: "";
          width: auto;
          left: 47px;
          top: 30px;
          font-size: 13px;
          color: #b7c6cd;
          position: absolute;
        }

        &__statistics__box {
          &:before,
          &:after {
            content: unset;
            display: none;
          }
        }
      }

      &__body {
        padding-left: 160px;
        position: relative;
        margin-top: -14px;

        &__row {
          padding: 9px 16px;
          border-left: solid #d8dfe3;
          display: flex;
          align-items: center;
          position: relative;

          &__info {
            color: #4c8dbb;
            font-size: 18px;
            max-width: calc(40vw - 42px);
            display: flex;
            align-items: center;
            flex-grow: 1;
            padding-right: 16px;
            padding-left: 35px;
            position: relative;

            span {
              cursor: pointer;
              font: normal normal normal 16px/22px Open Sans;
              letter-spacing: 0px;
              color: #4c8dbb;
            }

            .pointer {
              cursor: pointer;
            }

            & span {
              flex-grow: 1;
              margin-left: 12px;

              &:before {
                content: "";
                background-color: #d8dfe3;
                position: absolute;
                display: block;
                width: 55px;
                height: 2px;
                left: -16px;
                margin-top: 10px;
              }
            }

            &__overview,
            &__policy {
              padding: 0 15px;
              border: solid rgba(112, 112, 112, 0.27);
              text-align: center;
              font-size: 15px;
            }

            &__overview {
              border-width: 0 0 0 1px;
              padding-right: 0;
              font-style: normal;
            }

            &__policy {
              font-style: normal;
              border-width: 0 0 0 1px;
            }
          }
          &__statistics {
            font-size: 22px;
            width: 115px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #4c8dbb;
            z-index: 999;
          }
        }
      }
    }
  }
}
</style>
